"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _recharts = require("recharts");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var BarChartComponent = /*#__PURE__*/_react["default"].memo(function (_ref) {
  var data = _ref.data,
      color1 = _ref.color1,
      color2 = _ref.color2,
      width = _ref.width,
      height = _ref.height,
      hideX = _ref.hideX,
      hideY = _ref.hideY,
      axisLineX = _ref.axisLineX,
      axisLineY = _ref.axisLineY,
      tickLineX = _ref.tickLineX,
      top = _ref.top,
      bottom = _ref.bottom,
      right = _ref.right,
      left = _ref.left,
      verticalAlign = _ref.verticalAlign,
      layout = _ref.layout,
      align = _ref.align,
      fontWeight = _ref.fontWeight,
      paddingTop = _ref.paddingTop,
      barSize = _ref.barSize,
      iconSize = _ref.iconSize,
      hideLegend = _ref.hideLegend,
      iconType = _ref.iconType,
      tooltips = _ref.tooltips,
      toolTipBackgroundColor = _ref.toolTipBackgroundColor,
      tooltipBorderColor = _ref.tooltipBorderColor,
      _ref$toolTipPadding = _ref.toolTipPadding,
      toolTipPadding = _ref$toolTipPadding === void 0 ? "0.5rem" : _ref$toolTipPadding,
      labelColor = _ref.labelColor,
      xDataKey = _ref.xDataKey,
      yDataKey = _ref.yDataKey,
      containerHeight = _ref.containerHeight,
      xDataLabel = _ref.xDataLabel,
      yDataKeyLabel = _ref.yDataKeyLabel;
  return /*#__PURE__*/_react["default"].createElement(_recharts.ResponsiveContainer, {
    width: "100%",
    height: containerHeight
  }, /*#__PURE__*/_react["default"].createElement(_recharts.BarChart, {
    width: width || 450,
    height: height || 200,
    data: data,
    margin: {
      top: top,
      right: right,
      left: left,
      bottom: bottom
    }
  }, /*#__PURE__*/_react["default"].createElement(_recharts.XAxis, {
    dataKey: xDataLabel,
    hide: hideX || false,
    axisLine: axisLineX,
    tickLine: tickLineX || false,
    tick: {
      fill: labelColor
    },
    style: {
      fontWeight: {
        fontWeight: fontWeight
      },
      paddingTop: {
        paddingTop: paddingTop
      }
    }
  }), /*#__PURE__*/_react["default"].createElement(_recharts.YAxis, {
    hide: hideY || false,
    dataKey: yDataKeyLabel,
    axisLine: axisLineY
  }), tooltips ? /*#__PURE__*/_react["default"].createElement(_recharts.Tooltip, {
    content: tooltips,
    wrapperStyle: {
      backgroundColor: toolTipBackgroundColor,
      padding: toolTipPadding,
      border: "1px solid ".concat(tooltipBorderColor)
    },
    cursor: false
  }) : /*#__PURE__*/_react["default"].createElement(_recharts.Tooltip, {
    cursor: false
  }), !hideLegend && /*#__PURE__*/_react["default"].createElement(_recharts.Legend, {
    iconType: iconType,
    verticalAlign: verticalAlign,
    layout: layout,
    align: align,
    wrapperStyle: {
      paddingLeft: "20px"
    },
    iconSize: iconSize
  }) || null, xDataKey && /*#__PURE__*/_react["default"].createElement(_recharts.Bar, {
    dataKey: xDataKey,
    stackId: "a",
    fill: color1,
    barSize: barSize
  }) || null, yDataKey && /*#__PURE__*/_react["default"].createElement(_recharts.Bar, {
    dataKey: yDataKey,
    stackId: "a",
    fill: color2,
    barSize: barSize
  }) || null));
});

var _default = BarChartComponent;
exports["default"] = _default;